import ModulesPage from '@/components/modules/ModulesPage.vue';
import DetailModule from '@/components/modules/DetailModule.vue';
import ContentModule from '@/components/modules/ContentModule.vue';

const moduleRoutes = [{
    path: '/modules',
    component: ModulesPage,
    meta: {
        requiresAuth: false, // Allow public access to browse modules
        title: "Course Modules | Akademi Siber"
    },
},
{
    path: '/modules/:id',
    component: DetailModule,
    meta: {
        requiresAuth: false, // Allow public access to view module details
        title: "Module Detail | Akademi Siber"
    },
},
{
    path: '/modules/pages/:id',
    component: ContentModule,
    meta: {
        requiresAuth: true, // Require auth for accessing actual content
        title: "Course Content | Akademi Siber"
    },
}
];

export default moduleRoutes;